<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 bg-l-gray" 
         data-bs-scroll="true" 
         data-bs-backdrop="true" 
         tabindex="-1" 
         id="offcanvasAttach" 
         aria-labelledby="offcanvasAttachLabel"
         @blur="focusOff()"
      >
      <!--
         data-bs-backdrop="false" 
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasAttachLabel">Adjuntos</h6>
         <button type="button" 
            id="btn_close_offcanvas_attach"
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_close_offcanvas_attach"
            :disabled="loading"
         ></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body">
         <div v-show="!selectedFiles">
            <h6 class="pb-1">Seleccionar los Archivos</h6>
            <input 
               type="file" 
               id="fileToUpload" 
               ref="file" 
               multiple
               @change="selectFile" 
            />
            <div v-if=" attachs.length > 0 ">
               <hr class="p-0"/>
               <h6 class="pb-1">Recuperar Archivo(s)</h6>
               <!-- -->
               <div class="col-12 col-md-11 pb-2">
                  <label 
                     v-for="(attach, index) in attachs" 
                     :key="index" 
                     class="col-12 row py-2"
                  >
                     <div class="col-4 col-sm-3 col-md-3">
                        <view-attach 
                           :attach="attach" 
                           :cell_id="Number(cellId)"
                           :putOff="true"
                           />
                     </div>
                     <div class="col-8 col-sm-9 col-md-9">
                        <div class="fs-13 pt-1"><b>{{attach.name}}</b></div>
                        <div class="tc-gray fs-12"><b>{{dateTime(attach.timeStamp)}}</b></div>
                        <button class="btn btn-sm btn-link ps-2"
                           type="button"
                           @click="retrieveAtt(attach.id)"
                        >
                           Recuperar
                        </button>
                     </div>
                  </label>
               </div>
               <!-- -->
            </div>
         </div>
         <div v-if="selectedFiles">
            Archivos seleccionados ({{selectedFiles.length}}):
            <ul class="list-group py-2">
               <!--
               <li class="list-group-item">
                  Archivo seleccionado: <b>{{file.files.item(0).name}}</b>
               </li>
               -->
               <li v-for="n in selectedFiles.length" :key="n"
                  class="list-group-item p-0 rounded">
                  <div class="row justify-content-between m-0 align-items-center py-2">
                     <div class="col-11"> 
                        {{selectedFiles.item(n-1).name}}
                     </div>
                     <div v-if="loadingFile[n-1] != null" class="col-1 text-center p-0">
                        <div v-if="loadingFile[n-1]" class="spinner-grow spinner-grow-sm" role="status">
                           <span class="visually-hidden"></span>
                        </div>
                        <div v-else>
                           <svg v-if="!messages[n-1]" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
                              <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                           </svg>
                        </div>
                     </div>
                  </div>
                  <div v-if="messages[n-1]" class="alert p-1 m-0" :class="'alert-danger'">
                     {{ messages[n-1] }}
                  </div>
               </li>
            </ul>
            <div v-if="loading" class="btt-attach btn-save rounded">
               <span class="spinner-border spinner-border-sm"></span>
               Adjuntando archivos
            </div>
            <div v-else>
               <div v-if="endAttachs" class="btt-attach btn-save rounded" @click="btn_close_offcanvas_attach.click()">
                  Salir 
               </div>
               <div v-else class="btt-attach btn-save rounded" @click="uploadAll">
                  Adjuntar
               </div>
            </div>
         </div>
      </div>
   </div>
   </div>
   <!--
    <button class="btn btn-success" :disabled="!selectedFiles" @click="upload">
         <label class="col-12 bg-light rounded-3 border p-2">
            <input type="file" id="fileToUpload" ref="file" @change="selectFile" />
         </label>
   -->
</template>

<script>
//import { ref, watchEffect, nextTick } from 'vue';
import { ref, onMounted, watchEffect } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment';
import WspService from "../workSpace.service";

import ViewAttach from '../components/ViewAttach.vue';

export default {
   
   components: {
      ViewAttach
   },
   setup() {
      const store = useStore()

      const btn_close_offcanvas_attach = ref(null)

      const attachs = ref([])
      const boardId = ref(null)
      const cellId = ref(0)
      const cnttId = ref(store.state.wspace.contentId)
      const content = ref({})
      const file = ref(null)
      const loading = ref(false)
      //const message = ref("")
      const selectedFiles = ref(undefined)
      const showInput = ref(false)

      const endAttachs = ref(false)
      const loadingFile = ref([])
      const messages = ref([])

      const countAttach = ref(-1)
      watchEffect(() => {
         if ( countAttach.value > -1) {
            if ( countAttach.value == 0 ) {
               loading.value = false
               endAttachs.value = true
               countAttach.value = -1
            }
         }
      })

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasAttach')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         getContent(cnttId.value)
         myOffCanvas.focus()
         console.log(" show Attach's OC")
         countAttach.value = -1
         selectedFiles.value = false
         loading.value = false
         endAttachs.value = false
         loadingFile.value = []
         messages.value = []
         boardId.value = WspService.getBoardId(store)
         attachs.value = []
         getAttachs(boardId.value, cnttId.value)
         document.getElementById('fileToUpload').value = null
         document.getElementById('fileToUpload').click()
         })
         console.log("Attach's OC")
      })
      
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY HH:mm');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }

      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function focusOff() {
         console.log('out-focus-attach')
         //message.value = ""
         store.dispatch("wspace/setOffCanvas", 6)
         store.dispatch("wspace/setContentId", -6)
      }

      function getAttachs(boardId, contentId) {
         WspService.getAttachs(boardId, contentId, true)
         .then(response => {
            console.log(response.data)
            attachs.value = response.data
            //if (attachs.value.length > 0)
              // viewAttach.value = true
            //console.log("users-len: "+users.value.length)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function retrieveAtt(attachId) {
         let cnttData = {}
            cnttData.retrieveAttachId = attachId
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,   // boardId
            'ATR',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log(response)
            btn_close_offcanvas_attach.value.click();
            store.dispatch("wspace/setContentId", -7)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function selectFile(event) {
         selectedFiles.value = event.target.files
         for (let i = 0; i < selectedFiles.value.length; i++) {
            loadingFile.value.push(null)
            messages.value.push("")
         }
      }

      function uploadAll() {
         loading.value = true
         countAttach.value = selectedFiles.value.length
         for (let i = 0; i < selectedFiles.value.length; i++) {
            upload( i )
            //let promise = Promise.resolve( upload( i ))
            //await promise
            console.log(i)
         }
      }

      function upload( index ) {
         //loading.value = true
         loadingFile.value[ index ] = true
         //
         WspService.addAttachContent(
            cnttId.value,     // contentId, 
            cellId.value,    // cellId,
            boardId.value,
            store.state.auth.user.id,     // userId, 
            selectedFiles.value.item( index )   // attachFile
         )
         .then(response => {            
            console.log(response.data)
            console.log("attach ok: ")
            store.dispatch("wspace/setContentId", -6)
           //selectedFiles.value = false
            // // // document.getElementById('fileToUpload').value = null
            //document.getElementById('btn_close_offcanvas').click()
            //store.dispatch("wspace/setContentId", -6)
            //loading.value = false
            loadingFile.value[ index ] = false
            //endAttachs.value = true
            //btn_close_offcanvas_attach.value.click();
            countAttach.value = countAttach.value - 1
            console.log('OK('+index+')')
         })
         .catch(error => {
            messages.value[ index ] = 
               (
                  error.response &&
                  error.response.data &&
                  error.response.data.message
               ) ||
               "Error de sistema (Attach): " + error.message ||
               error.toString();
            //loading.value = false
            loadingFile.value[ index ] = false
            //console.log(message.value);
            countAttach.value = countAttach.value - 1
            console.log('ERROR('+index+')')
         });
      }

      return {
         attachs,
         cellId,
         cnttId,
         content,
         countAttach,
         dateTime,
         endAttachs,
         file,
         focusOff,
         loading, loadingFile,
         messages,   //message,
         retrieveAtt,
         selectFile,
         selectedFiles,
         showInput,
         upload, uploadAll,
         btn_close_offcanvas_attach
      }
   }
}
</script>

<style scoped>
@media (min-width: 768px) {
   .offcanvas-end {
   top: 25px;
   right: 100px;
   width: 600px;
   height: fit-content;
   }
}
@media (max-width: 767px) {
   .offcanvas-end {
   top: 25px;
   right: 10%;
   width: 80%;
   height: fit-content;
   }
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.bg-l-gray {
   background-color:  #ecf0f1 ;
}
.btt-attach {
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>